// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"456":"b7c8ad37","751":"f4ce7821","765":"ee16378e","836":"7e55525d"}[chunkId] + ".chunk.js";
};